var _defs, _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack160({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 7.5,
    y: 11.3,
    width: 1,
    height: 6,
    rx: 0.5,
    transform: "translate(-6.3 22.3) rotate(-90)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.5,5.8a.5.5,0,0,0-1,0v8h1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.5,5.8a.5.5,0,0,0-1,0v8h1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,1.2a4.49,4.49,0,0,0-.5,9V5.8a.5.5,0,0,1,1,0v4.35a4.49,4.49,0,0,0-.5-9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,3.35A2.35,2.35,0,0,0,7.5,8V5.8a.5.5,0,0,1,1,0V8A2.35,2.35,0,0,0,8,3.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack160);
export default __webpack_public_path__ + "static/media/Symbolpack_1_60.31f925cf40da3d80999c80c5ff6b9497.svg";
export { ForwardRef as ReactComponent };